import React from "react";
import { useTranslation } from "react-i18next";
import UserService, { UserDocument } from "../services/user.service";
import generalStyles from "../styles/generals.module.scss";
import SmallArrowImage from "../img/small-arrow.svg";
import noDocuments from "../img/no-documents.svg";
import styles from "../styles/pages/profile.module.scss";
import Loading from "../components/loading/Loading";
import { Browser } from "@capacitor/browser";

export default function Documents({
  documents,
  loading,
}: {
  documents: UserDocument[];
  loading: boolean;
}) {
  const { t } = useTranslation("profile");

  return (
    <>
      <div className={`${generalStyles.title} ${generalStyles.align_center}`}>
        {t("documents")}
      </div>
      {documents && documents.length ? (
        <div className={styles.profile}>
          <div className={styles.items}>
            {documents.map((document, i) => {
              return (
                <div
                  className={`${styles.item} ${styles.itemWithBottomLine}`}
                  key={i}
                  onClick={async (e) => {
                    e.preventDefault();
                    const url = await UserService.getDocumentUrl(document);
                    Browser.open({
                      url: url.file_url,
                      windowName: "_self",
                    });
                  }}
                >
                  <div>
                    <div className={styles.itemCategory}>
                      {t(document.type_name)}
                    </div>
                    <div className={styles.itemText}>
                      {document.name.replace(/_/g, " ")}
                    </div>
                  </div>
                  <div className={styles.itemArrow}>
                    <img
                      src={SmallArrowImage}
                      height={20}
                      width={10}
                      alt="arrow"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <>
          <div className={styles.no_documents}>
            <h3>{loading ? <Loading /> : t("no_documents")}</h3>
            <img src={noDocuments} width={270} height={300} />
          </div>
        </>
      )}
    </>
  );
}
